import React, { useEffect, useState } from "react";
import "./Videos.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import { FaPlay, FaTimes } from "react-icons/fa";

/* 12 YOUTUBE SHORTS VIDEO IDS */
const videos = [
  "IoDlfcdsorY", "7QEQaOZNik4", "4f78O35fVFw", "J0kPNbxk18M",
  "5oeRc2Xb5vI", "NlTYk8tRdC4", "fxamyvK6Ox4", "2vFkN268CN0",
  "hldi1or1dEI", "SOtltIM3B_M", "RUT1XzWtP4g", "UhYcEPhmLXk"
];

const Videos = () => {
  const { t } = useTranslation();
  const [activeVideo, setActiveVideo] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true
    });
  }, []);

  return (
    <div className="videos_page">
      {/* HEADER SECTION */}
      <div className="videos_header">
        <h1>
          {t('videos.title_start')} <span>{t('videos.title_end')}</span>
        </h1>
        <p>
          {t('videos.subtitle')} <strong>{t('common.org_name')}</strong>
        </p>
      </div>

      <div className="videos_grid">
        {videos.map((id, index) => (
          <div
            key={index}
            className="video_card"
            data-aos="zoom-in"
            data-aos-delay={index * 40}
            onClick={() => setActiveVideo(id)}
          >
            <img
              src={`https://img.youtube.com/vi/${id}/hqdefault.jpg`}
              alt={t('videos.thumbnail_alt')}
            />
            <div className="video_overlay">
              <div className="play_button">
                <FaPlay />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* VIDEO POPUP */}
      {activeVideo && (
        <div className="video_popup" onClick={() => setActiveVideo(null)}>
          <div className="video_modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="close_button"
              onClick={() => setActiveVideo(null)}
            >
              <FaTimes />
            </button>
            <iframe
              src={`https://www.youtube.com/embed/${activeVideo}?autoplay=1`}
              title="YouTube Short"
              allow="autoplay; encrypted-media"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default Videos;